module.exports = [
  {
    name: 'DiversionSeries',
    content: [
      {
        id: 1,
        en: {
          title: 'Diversion',
          url: 'https://www.amazon.co.jp/dp/B00LIC5J00?tag=muchimemo-22',
        },
        ja: {
          title: '還流',
          url: 'https://www.amazon.co.jp/dp/B01LZ2CASG?tag=muchimemo-22',
        },
        review: 'diversion',
      },
      {
        id: 2,
        en: {
          title: 'Collusion',
          url: 'https://www.amazon.co.jp/dp/B00ZDFRJCO?tag=muchimemo-22',
        },
        ja: {
          title: '密計',
          url: 'https://www.amazon.co.jp/dp/B0C7GBYJK4?tag=muchimemo-22',
        },
        review: 'collusion',
      },
      {
        id: 3,
        en: {
          title: 'Corruption',
          url: 'https://www.amazon.co.jp/dp/B00FJJKFXY?tag=muchimemo-22',
        },
        ja: {
          title: '',
          url: '',
        },
        review: '',
      },
      {
        id: 4,
        en: {
          title: 'Manipulation',
          url: 'https://www.amazon.co.jp/dp/B00OWHYXNW?tag=muchimemo-22',
        },
        ja: {
          title: '',
          url: '',
        },
        review: '',
      },
      {
        id: 5,
        en: {
          title: 'Redemption',
          url: 'https://www.amazon.co.jp/dp/B012XXT5TI?tag=muchimemo-22',
        },
        ja: {
          title: '',
          url: '',
        },
        review: '',
      },
      {
        id: 6,
        en: {
          title: 'Reunion',
          url: 'https://www.amazon.co.jp/dp/B07483PVDF?tag=muchimemo-22',
        },
        ja: {
          title: '',
          url: '',
        },
        review: '',
      },
      {
        id: 7,
        en: {
          title: 'Suspicion',
          url: 'https://www.amazon.co.jp/dp/B07LDYVBTV?tag=muchimemo-22',
        },
        ja: {
          title: '',
          url: '',
        },
        review: '',
      },
      {
        id: 7.1,
        en: {
          title: 'Relation',
          url: 'https://www.amazon.co.jp/dp/B081LFRLFW?tag=muchimemo-22',
        },
        ja: {
          title: '',
          url: '',
        },
        review: '',
      },
      {
        id: 7.2,
        en: {
          title: 'Tradition(Free)',
          url: 'https://dl.bookfunnel.com/i5w7vtoq79',
        },
        ja: {
          title: '',
          url: '',
        },
        review: '',
      },
      {
        id: 8,
        en: {
          title: 'Decision',
          url: 'https://www.amazon.co.jp/dp/B084T1DGBH?tag=muchimemo-22',
        },
        ja: {
          title: '',
          url: '',
        },
        review: '',
      },
      {
        id: 9,
        en: {
          title: 'Benediction',
          url: 'https://www.amazon.co.jp/dp/B08R3T3L1W?tag=muchimemo-22',
        },
        ja: {
          title: '',
          url: '',
        },
        review: '',
      },
    ],
  },
  {
    name: 'AdrienEnglishSeries',
    content: [
      {
        id: 1,
        en: {
          title: 'Fatal Shadows',
          url: 'https://www.amazon.co.jp/dp/B007ZRH38I?tag=muchimemo-22',
        },
        ja: {
          title: '天使の影',
          url: 'https://www.amazon.co.jp/dp/B00KW25SO4?tag=muchimemo-22',
        },
        review: 'fatal-shadow',
      },
      {
        id: 2,
        en: {
          title: 'A Dangerous Thing',
          url: 'https://www.amazon.co.jp/dp/B0081C8RU4?tag=muchimemo-22',
        },
        ja: {
          title: '死者の囁き',
          url: 'https://www.amazon.co.jp/dp/B00KW25SP8?tag=muchimemo-22',
        },
        review: 'a-dangerous-thing',
      },
      {
        id: 3,
        en: {
          title: 'The Hell You Say',
          url: 'https://www.amazon.co.jp/dp/B006LNC468?tag=muchimemo-22',
        },
        ja: {
          title: '悪魔の聖餐',
          url: 'https://www.amazon.co.jp/dp/B00N8RVP24?tag=muchimemo-22',
        },
        review: '',
      },
      {
        id: 4,
        en: {
          title: 'Death of a Pirate King',
          url: 'https://www.amazon.co.jp/dp/B0067QUX9E?tag=muchimemo-22',
        },
        ja: {
          title: '海賊王の死',
          url: 'https://www.amazon.co.jp/dp/B00U6WBU2E?tag=muchimemo-22',
        },
        review: '',
      },
      {
        id: 5,
        en: {
          title: 'The Dark Tide',
          url: 'https://www.amazon.co.jp/dp/B006N9XHLQ?tag=muchimemo-22',
        },
        ja: {
          title: '瞑き流れ',
          url: 'https://www.amazon.co.jp/dp/B01BL25AEG?tag=muchimemo-22',
        },
        review: '',
      },
      {
        id: 6,
        en: {
          title: 'So This is Christmas',
          url: 'https://www.amazon.co.jp/dp/B01N9AERR2?tag=muchimemo-22',
        },
        ja: {
          title: 'So This is Christmas',
          url: 'https://www.amazon.co.jp/dp/B077ZGFZ7S?tag=muchimemo-22',
        },
        review: '',
      },
    ],
  },
  {
    name: 'AllsFairSeries',
    content: [
      {
        id: 1,
        en: {
          title: 'Fair Game',
          url: 'https://www.amazon.co.jp/dp/B003U89S66?tag=muchimemo-22',
        },
        ja: {
          title: 'フェア･ゲーム',
          url: 'https://www.amazon.co.jp/dp/B00CB7WV66?tag=muchimemo-22',
        },
        review: 'fair-game',
      },
      {
        id: 2,
        en: {
          title: 'Fair Play',
          url: 'https://www.amazon.co.jp/dp/B00KV5Z7M0?tag=muchimemo-22',
        },
        ja: {
          title: 'フェア･プレイ',
          url: 'https://www.amazon.co.jp/dp/B01MUOQTHX?tag=muchimemo-22',
        },
        review: 'fair-play',
      },
      {
        id: 3,
        en: {
          title: 'Fair Chance',
          url: 'https://www.amazon.co.jp/dp/B01MSLD8L2?tag=muchimemo-22',
        },
        ja: {
          title: 'フェア･チャンス',
          url: 'https://www.amazon.co.jp/dp/B083NX8Q66?tag=muchimemo-22',
        },
        review: 'fair-chance',
      },
    ],
  },
  {
    name: 'HowlAtTheMoonSeries',
    content: [
      {
        id: 1,
        en: {
          title: 'How to Howl at the Moon',
          url: 'https://www.amazon.co.jp/dp/B00T12QQOW?tag=muchimemo-22',
        },
        ja: {
          title: '月への吠えかた教えます',
          url: 'https://www.amazon.co.jp/dp/B07J67WTTM?tag=muchimemo-22',
        },
        review: 'how-to-howl-at-the-moon',
      },
      {
        id: 2,
        en: {
          title: 'How to Walk Like a Man',
          url: 'https://www.amazon.co.jp/dp/B0176KQPH8?tag=muchimemo-22',
        },
        ja: {
          title: 'ヒトの世界の歩きかた',
          url: 'https://www.amazon.co.jp/dp/B07YXLFLG9?tag=muchimemo-22',
        },
        review: 'how-to-walk-like-a-man',
      },
      {
        id: 3,
        en: {
          title: 'How to Wish Upon a Star',
          url: 'https://www.amazon.co.jp/dp/B01FISHWJK?tag=muchimemo-22',
        },
        ja: {
          title: '星に願いをかけるには',
          url: 'https://www.amazon.co.jp/dp/B08MW9PG12?tag=muchimemo-22',
        },
        review: '',
      },
      {
        id: 4,
        en: {
          title: 'How to Save a Life',
          url: 'https://www.amazon.co.jp/dp/B0751ZW6XG?tag=muchimemo-22',
        },
        ja: {
          title: '',
          url: '',
        },
        review: '',
      },
      {
        id: 5,
        en: {
          title: 'How To Run With The Wolves',
          url: 'https://www.amazon.co.jp/dp/B07VD891ZV?tag=muchimemo-22',
        },
        ja: {
          title: '',
          url: '',
        },
        review: '',
      },
    ],
  },
  {
    name: 'TheArtOfMurderSeries',
    content: [
      {
        id: 1,
        en: {
          title: 'The Mermaid Murders',
          url: 'https://www.amazon.co.jp/dp/B018UJ80EA?tag=muchimemo-22',
        },
        ja: {
          title: 'マーメイド･マーダーズ',
          url: 'https://www.amazon.co.jp/dp/B07L8WN6FL?tag=muchimemo-22',
        },
        review: 'the-mermaid-murders',
      },
      {
        id: 2,
        en: {
          title: 'The Monet Murders',
          url: 'https://www.amazon.co.jp/dp/B01MYC6ZOZ?tag=muchimemo-22',
        },
        ja: {
          title: 'モネ･マーダーズ',
          url: 'https://www.amazon.co.jp/dp/B082H6P92M?tag=muchimemo-22',
        },
        review: 'the-monet-murders',
      },
      {
        id: 3,
        en: {
          title: 'The Magician Murders',
          url: 'https://www.amazon.co.jp/dp/B07C9TM55R?tag=muchimemo-22',
        },
        ja: {
          title: '',
          url: '',
        },
        review: '',
      },
      {
        id: 4,
        en: {
          title: 'The Monuments Men Murders',
          url: 'https://www.amazon.co.jp/dp/B07R818GZ9?tag=muchimemo-22',
        },
        ja: {
          title: '',
          url: '',
        },
        review: '',
      },
    ],
  },
]
